"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _RenderInBody;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @description Render React components at the top-level of the document body.
 * @usedBy ModalBase, Select
 */

var defaultProps = {
  orderedKeyDownHandler: false
};
var RenderInBody = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RenderInBody, _React$Component);
  function RenderInBody(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RenderInBody);
    _this = _callSuper(this, RenderInBody, [props]);

    // Adds a keydown event listener to the document body if it has not been added yet.
    // Sets isHandlersActive flag.
    if (!RenderInBody.isHandlersActive && typeof document !== 'undefined') {
      document.body.addEventListener('keydown', RenderInBody.handleKeyDown);
      RenderInBody.isHandlersActive = true;
    }
    return _this;
  }

  /**
   * Adds a keydown event listener to the document body if the `onKeyDown` prop is provided.
   * @param {function} onKeyDown - The keydown event handler to be added.
   * @param {boolean} orderedKeyDownHandler - Indicates whether the keydown event handler should be added to the `RenderInBody.handlers` array.
   */
  (0, _createClass2["default"])(RenderInBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        onKeyDown = _this$props.onKeyDown,
        orderedKeyDownHandler = _this$props.orderedKeyDownHandler;
      if (onKeyDown) {
        if (orderedKeyDownHandler) {
          RenderInBody.handlers.push(onKeyDown);
        } else {
          document.body.addEventListener('keydown', onKeyDown);
        }
      }
    }

    /**
     * Unregisters the keydown event handler.
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
        onKeyDown = _this$props2.onKeyDown,
        orderedKeyDownHandler = _this$props2.orderedKeyDownHandler;
      if (onKeyDown) {
        if (orderedKeyDownHandler) {
          RenderInBody.handlers.splice(RenderInBody.handlers.indexOf(onKeyDown), 1);
        } else {
          document.body.removeEventListener('keydown', onKeyDown);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
        tabIndex: "-1"
      }, this.props.children), document.body);
    }
  }]);
  return RenderInBody;
}(_react["default"].Component);
_RenderInBody = RenderInBody;
(0, _defineProperty2["default"])(RenderInBody, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(RenderInBody, "handlers", []);
/**
 * @description When a keydown event occurs, the handleKeyDown method is called,
 * and it checks if there is a current handler in the handlers array. If there is,
 * it calls the current handler with the event object as an argument.
 *
 * This means that the handleKeyDown method is responsible for calling the appropriate keydown
 * handler based on the order in which they were registered or added to the document body.
 */
(0, _defineProperty2["default"])(RenderInBody, "handleKeyDown", function (e) {
  var currentHandler = _RenderInBody.handlers[_RenderInBody.handlers.length - 1];
  if (currentHandler) {
    currentHandler(e);
  }
});
(0, _defineProperty2["default"])(RenderInBody, "isHandlersActive", false);
//# sourceMappingURL=index.js.map